module.exports = __webpack_public_path__ + "img/体育培训_2@2x.4b508fe6.png";